import { createRoomSelectorApiClient } from '@/scopes/prices/infrastructure/rooms/roomSelectorApiClient'

export const roomSelectorApiClient = createRoomSelectorApiClient()
